import { faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useContext } from "react"
import { Link } from "react-router-dom"
import DefaultLogo from "../../assets/logoDefault.png"
import { ErrorRefreshFallback } from "../../components/ErrorRefreshFallback"
import { PanelButton } from "../../components/PanelButton"
import { KeycloakContext } from "../../context/KeycloakContext"
import { ClinicType } from "../../interfaces/LoginSecurity"

const ChevronLink = ({ clinic }: { clinic: ClinicType }) => {
  return (
    <Link to={`/clinics/${clinic.guid}`} state={{ data: clinic }}>
      <FontAwesomeIcon className="text-janeBlack" icon={faChevronRight} />
    </Link>
  )
}

export const ClinicList = () => {
  const { clinics, error } = useContext(KeycloakContext)
  const clinicListError = error?.clinicError
  if (clinicListError) {
    return <ErrorRefreshFallback />
  }

  if (clinics.length === 0) {
    return (
      <PanelButton
        className={`rounded p-6 flex justify-between items-center bg-white`}
        subtitle={"You have no linked profiles."}
      />
    )
  }

  if (clinics.length === 1) {
    const clinic = clinics[0]
    return (
      <PanelButton
        className={`rounded p-6 flex justify-between items-center bg-white`}
        key={clinic.guid}
        title={clinic.name}
        interactiveButton={<ChevronLink clinic={clinic} />}
        imgSrc={clinic.logo_thumbnail_url}
        fallbackImage={DefaultLogo}
        subtitle={clinic.lookup_address}
      />
    )
  }

  const panelButtonClinics = clinics.map((clinic, idx) => {
    const isFirstItem = idx === 0
    const isLastItem = idx === clinics.length - 1
    const isRegularItem = idx !== 0 && idx !== clinics.length - 1

    // Items that are neither first or last should get no rounded borders.
    let rounded
    if (isFirstItem) {
      rounded = "rounded-t"
    } else if (isLastItem) {
      rounded = "rounded-b"
    } else {
      rounded = ""
    }

    return (
      <PanelButton
        className={`${rounded} p-6 flex justify-between items-center bg-white`}
        key={clinic.guid}
        title={clinic.name}
        interactiveButton={<ChevronLink clinic={clinic} />}
        borderBottomNone={isFirstItem || isRegularItem}
        imgSrc={clinic.logo_thumbnail_url}
        fallbackImage={DefaultLogo}
        subtitle={clinic.lookup_address}
      />
    )
  })
  return <>{panelButtonClinics}</>
}
